<div
  class="flex items-center"
  auxSkeletonLoader
  [loading]="(datasource.loading$ | async) === true"
  data-pendo-id="export-full-dataset"
>
  <p>Showing 250 of {{ totalRows() }} records</p>
  <aux-button
    class="pl-2 pr-8"
    variant="hyperlink"
    label="Export full dataset"
    (click)="exportDataset()"
    [loading]="isProcessing()"
    [spinnerSize]="5"
  />
</div>
